import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import type { ReactNode } from 'react';
import { MetricTrendPanel, type MetricTrendPanelProps, TREND_CARD_WIDTH } from './MetricTrendPanel';

const DIALOG_PAPER_SX = { width: TREND_CARD_WIDTH, maxWidth: '90vw' };

interface MetricTrendDialogProps extends MetricTrendPanelProps {
  onClose: () => void;
}

export function MetricTrendDialog({
  scope,
  metric,
  currencySymbol,
  onClose,
}: MetricTrendDialogProps): ReactNode {
  return (
    <Dialog open onClose={onClose} maxWidth={false} slotProps={{ paper: { sx: DIALOG_PAPER_SX } }}>
      <DialogContent sx={{ p: 3 }}>
        <IconButton
          size="small"
          onClick={onClose}
          aria-label="Close"
          sx={{ position: 'absolute', top: 12, right: 12, color: 'text.secondary' }}
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
        <MetricTrendPanel scope={scope} metric={metric} currencySymbol={currencySymbol} />
      </DialogContent>
    </Dialog>
  );
}
